/**
 * OneTrust utility functions for cookie consent banner management
 *
 * @see https://developer.onetrust.com/onetrust/docs/single-page-applications
 */

import { Language } from "@ubnt/store.core/lib/types";

// Extend window type for TypeScript
declare global {
  interface Window {
    OneTrust?: {
      ToggleInfoDisplay?: (forceShow?: boolean) => void;
      changeLanguage?: (language: string) => void;
    };
  }
}

const getLanguageCode = (language?: string): string => {
  const lowercasedLang = language?.toLowerCase() ?? Language.En;
  if (lowercasedLang.includes("-")) {
    // @NOTE Extract primary language code (Taiwanese not supported yet)
    return lowercasedLang.split("-")[0];
  }
  return lowercasedLang;
};

/**
 * Handles OneTrust banner during language change.
 *
 * @param language - The language code (e.g., 'en', 'es-es', 'pt-br', 'ja')
 */
export const handleOneTrust = (language?: string): void => {
  if (!window.OneTrust) {
    return undefined;
  }
  
  window.OneTrust.changeLanguage?.(getLanguageCode(language));

  setTimeout(() => {
    window.OneTrust.ToggleInfoDisplay?.(true);
  }, 1000);
};

export default handleOneTrust;
